import { isValidStructuredCommunicationBE } from 'utils/constants';

type IQRCodePayload = {
  name: string;
  bic?: string;
  iban: string;
  amount: number;
  reference?: string;
  information?: string;
};
// from old code
export const generateQRCodePayload = ({
  name,
  bic,
  iban,
  amount,
  reference,
  information,
}: IQRCodePayload): string =>
  [
    'BCD', // Service tag
    '002', // Version
    1, // Char set
    'SCT', // Identification code
    bic,
    name,
    iban,
    'EUR' + (amount || 0).toFixed(2),
    '', // purpose code
    reference && isValidStructuredCommunicationBE(reference) ? reference : '',
    reference && !isValidStructuredCommunicationBE(reference) ? reference : '',
    information || '',
  ].join('\n');

export const banksAvailable = [
  { value: 'Belfius', label: 'Belfius' },
  { value: 'ING', label: 'ING' },
  { value: 'KBC', label: 'KBC' },
];

export const bankSteps = {
  Belfius: [
    'expense.field.link_payment.pay_with_qr_code.steps.belfius.step1',
    'expense.field.link_payment.pay_with_qr_code.steps.belfius.step2',
    'expense.field.link_payment.pay_with_qr_code.steps.scan_the_qr_code',
  ],
  ING: [
    'expense.field.link_payment.pay_with_qr_code.steps.ing.step1',
    'expense.field.link_payment.pay_with_qr_code.steps.ing.step2',
    'expense.field.link_payment.pay_with_qr_code.steps.scan_the_qr_code',
  ],
  KBC: [
    'expense.field.link_payment.pay_with_qr_code.steps.kbc.step1',
    'expense.field.link_payment.pay_with_qr_code.steps.kbc.step2',
    'expense.field.link_payment.pay_with_qr_code.steps.kbc.step3',
    'expense.field.link_payment.pay_with_qr_code.steps.scan_the_qr_code',
  ],
};
